import {API} from '@utils'
import _ from "lodash"
//************************************//
export const _searchAssignments = async (q = '') => {
  const res =  await API.get('/assignment/search', {
    params: {
      limit: 20,
      q
    }
  })
  return _.map(res.data, (v, k) => {
    return {value: v.id, label: v.title}
  })
}
//************************************//
export function _getOverviewAnalyticsData(data, callback = () => {}, callbackError = () => {}) {
  return dispatch => {
    API.get(`/analytic/statistics`, {
      params: data
    })
      .then(callback)
      .catch(callbackError)
  }
}
//************************************//
export function _getInspectionsAnalyticsData(data, callback = () => {}, callbackError = () => {}) {
  return dispatch => {
    API.post(`/analytic/inspections`, data)
      .then(callback)
      .catch(callbackError)
  }
}
//************************************//
export function _getResponsesAnalyticsData(data, callback = () => {}, callbackError = () => {}) {
  return dispatch => {
    API.get(`/analytic/responses`, {
      params: data
    })
      .then(callback)
      .catch(callbackError)
  }
}
//************************************//
export function _getIssuesAnalyticsData(data, callback = () => {}, callbackError = () => {}) {
  return dispatch => {
    API.get(`/analytic/issues`, {
      params: data
    })
      .then(callback)
      .catch(callbackError)
  }
}

//************************************//
export const _clearAnalytics = (keys, loading = true) => {
  return dispatch => {
    const payload = {}
    _.forEach(keys, key => {
      payload[key] = {
        value: 0,
        loading,
        stats: []
      }
      // if (`${key}`.indexOf('statistic') > -1 || `${key}`.indexOf('bar') > -1 || `${key}` === 'inspections_total_score_issues_widget') {
      //   payload[key] = {
      //     value: 0,
      //     loading: true,
      //     stats: []
      //   }
      // } else {
      //   payload[key] = []
      // }

    })
    dispatch({
      type: 'ANALYTICS_CHARTS_DATA',
      payload: {
        filters: {},
        data: payload
      }
    })
  }
}
//************************************//
export const _searchUserGroups = async ({q = '', ids = []} = {}) => {
  return await API.get('/user/search-user-group', {
    params: {
      q,
      ids
    }
  })
    .catch(function (res) {})
}
//************************************//
export function submitAnalyticsWithFiltersAndKeys(keys, filters, dispatchFilters) {
  return dispatch => {
    dispatch(_clearAnalytics(keys))
    dispatch(
      _getOverviewAnalyticsData(
        {
          keys, filters
        },
        ({data}) => {
          dispatch({
            type: dispatchFilters ? 'ANALYTICS_CHARTS_DATA_WITH_FILTERS' : 'ANALYTICS_CHARTS_DATA',
            payload: data
          })
        }
      )
    )
  }
}
//************************************//
export function submitInspectionsAnalyticsWithFiltersAndKeys(keys, filters, dispatchFilters) {
  return dispatch => {
    dispatch(_clearAnalytics(keys))
    dispatch(
      _getInspectionsAnalyticsData(
        {
          keys, filters
        },
        ({data}) => {
          dispatch({
            type: dispatchFilters ? 'ANALYTICS_CHARTS_DATA_WITH_FILTERS' : 'ANALYTICS_CHARTS_DATA',
            payload: data
          })
        }
      )
    )
  }
}
//************************************//
export function submitResponsesAnalyticsWithFiltersAndKeys(keys, filters, dispatchFilters) {
  return dispatch => {
    dispatch(_clearAnalytics(keys))
    dispatch(
      _getResponsesAnalyticsData(
        {
          keys, filters
        },
        ({data}) => {
          dispatch({
            type: dispatchFilters ? 'ANALYTICS_CHARTS_DATA_WITH_FILTERS' : 'ANALYTICS_CHARTS_DATA',
            payload: data
          })
        }
      )
    )
  }
}
//************************************//
export function submitIssuesAnalyticsWithFiltersAndKeys(keys, filters, dispatchFilters) {
  return dispatch => {
    dispatch(_clearAnalytics(keys))
    dispatch(
      _getIssuesAnalyticsData(
        {
          keys, filters
        },
        ({data}) => {
          dispatch({
            type: dispatchFilters ? 'ANALYTICS_CHARTS_DATA_WITH_FILTERS' : 'ANALYTICS_CHARTS_DATA',
            payload: data
          })
        }
      )
    )
  }
}